import { 
  Box, 
  Typography, 
  TextField, 
  Accordion, 
  AccordionSummary, 
  AccordionDetails,
  Grid,
  FormControl,
  Select,
  MenuItem,
  IconButton,
  Button
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

export function WSPContactFields({ 
  localNodeData, 
  updateNodeData,
  addArrayItem,
  removeArrayItem,
  updateArrayItem,
  updateObjectField
}) {
  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
        Nombre del Contacto
      </Typography>
      <TextField
        value={localNodeData.contactName || ''}
        size="small"
        fullWidth
        onChange={(e) => updateNodeData('contactName', e.target.value)}
      />
      
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body2">Detalles del nombre</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <TextField
                label="Nombre"
                value={localNodeData.contactFirstName || ''}
                size="small"
                fullWidth
                onChange={(e) => updateNodeData('contactFirstName', e.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Apellido"
                value={localNodeData.contactLastName || ''}
                size="small"
                fullWidth
                onChange={(e) => updateNodeData('contactLastName', e.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Segundo nombre"
                value={localNodeData.contactMiddleName || ''}
                size="small"
                fullWidth
                onChange={(e) => updateNodeData('contactMiddleName', e.target.value)}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Prefijo"
                value={localNodeData.contactPrefix || ''}
                size="small"
                fullWidth
                onChange={(e) => updateNodeData('contactPrefix', e.target.value)}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Sufijo"
                value={localNodeData.contactSuffix || ''}
                size="small"
                fullWidth
                onChange={(e) => updateNodeData('contactSuffix', e.target.value)}
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      <Box sx={{ mt: 2 }}>
        <TextField
          label="Cumpleaños (YYYY-MM-DD)"
          value={localNodeData.contactBirthday || ''}
          size="small"
          fullWidth
          onChange={(e) => updateNodeData('contactBirthday', e.target.value)}
        />
      </Box>

      {/* Phones */}
      <Accordion sx={{ mt: 2 }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body2">Teléfonos</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {localNodeData.contactPhones?.map((phone, index) => (
            <Box key={index} sx={{ mb: 2, p: 1, border: '1px solid #ddd', borderRadius: 1 }}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs={4}>
                  <TextField
                    label="Teléfono"
                    value={phone.phone || ''}
                    size="small"
                    fullWidth
                    onChange={(e) => updateArrayItem('contactPhones', index, 'phone', e.target.value)}
                  />
                </Grid>
                <Grid item xs={3}>
                  <FormControl fullWidth size="small">
                    <Select
                      value={phone.type || 'CELL'}
                      onChange={(e) => updateArrayItem('contactPhones', index, 'type', e.target.value)}
                    >
                      <MenuItem value="CELL">Móvil</MenuItem>
                      <MenuItem value="MAIN">Principal</MenuItem>
                      <MenuItem value="HOME">Casa</MenuItem>
                      <MenuItem value="WORK">Trabajo</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    label="WhatsApp ID"
                    value={phone.waId || ''}
                    size="small"
                    fullWidth
                    onChange={(e) => updateArrayItem('contactPhones', index, 'waId', e.target.value)}
                  />
                </Grid>
                <Grid item xs={2}>
                  <IconButton
                    onClick={() => removeArrayItem('contactPhones', index)}
                    color="error"
                    size="small"
                  >
                    <DeleteIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </Box>
          ))}
          <Button
            startIcon={<AddIcon />}
            onClick={() => addArrayItem('contactPhones', { phone: '', type: 'CELL', waId: '' })}
            size="small"
          >
            Agregar teléfono
          </Button>
        </AccordionDetails>
      </Accordion>

      {/* Emails */}
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body2">Correos electrónicos</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {localNodeData.contactEmails?.map((email, index) => (
            <Box key={index} sx={{ mb: 2, p: 1, border: '1px solid #ddd', borderRadius: 1 }}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs={6}>
                  <TextField
                    label="Email"
                    value={email.email || ''}
                    size="small"
                    fullWidth
                    onChange={(e) => updateArrayItem('contactEmails', index, 'email', e.target.value)}
                  />
                </Grid>
                <Grid item xs={4}>
                  <FormControl fullWidth size="small">
                    <Select
                      value={email.type || 'HOME'}
                      onChange={(e) => updateArrayItem('contactEmails', index, 'type', e.target.value)}
                    >
                      <MenuItem value="HOME">Casa</MenuItem>
                      <MenuItem value="WORK">Trabajo</MenuItem>
                      <MenuItem value="OTHER">Otro</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2}>
                  <IconButton
                    onClick={() => removeArrayItem('contactEmails', index)}
                    color="error"
                    size="small"
                  >
                    <DeleteIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </Box>
          ))}
          <Button
            startIcon={<AddIcon />}
            onClick={() => addArrayItem('contactEmails', { email: '', type: 'HOME' })}
            size="small"
          >
            Agregar email
          </Button>
        </AccordionDetails>
      </Accordion>

      {/* Organization */}
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body2">Organización</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                label="Empresa"
                value={localNodeData.contactOrganization?.company || ''}
                size="small"
                fullWidth
                onChange={(e) => updateObjectField('contactOrganization', 'company', e.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Departamento"
                value={localNodeData.contactOrganization?.department || ''}
                size="small"
                fullWidth
                onChange={(e) => updateObjectField('contactOrganization', 'department', e.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Cargo"
                value={localNodeData.contactOrganization?.title || ''}
                size="small"
                fullWidth
                onChange={(e) => updateObjectField('contactOrganization', 'title', e.target.value)}
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      {/* Addresses */}
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body2">Direcciones</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {localNodeData.contactAddresses?.map((address, index) => (
            <Box key={index} sx={{ mb: 2, p: 1, border: '1px solid #ddd', borderRadius: 1 }}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <TextField
                    label="Calle"
                    value={address.street || ''}
                    size="small"
                    fullWidth
                    onChange={(e) => updateArrayItem('contactAddresses', index, 'street', e.target.value)}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    label="Ciudad"
                    value={address.city || ''}
                    size="small"
                    fullWidth
                    onChange={(e) => updateArrayItem('contactAddresses', index, 'city', e.target.value)}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    label="Estado/Región"
                    value={address.state || ''}
                    size="small"
                    fullWidth
                    onChange={(e) => updateArrayItem('contactAddresses', index, 'state', e.target.value)}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    label="Código postal"
                    value={address.zip || ''}
                    size="small"
                    fullWidth
                    onChange={(e) => updateArrayItem('contactAddresses', index, 'zip', e.target.value)}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    label="País"
                    value={address.country || ''}
                    size="small"
                    fullWidth
                    onChange={(e) => updateArrayItem('contactAddresses', index, 'country', e.target.value)}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    label="Código país"
                    value={address.countryCode || ''}
                    size="small"
                    fullWidth
                    onChange={(e) => updateArrayItem('contactAddresses', index, 'countryCode', e.target.value)}
                  />
                </Grid>
                <Grid item xs={2}>
                  <FormControl fullWidth size="small">
                    <Select
                      value={address.type || 'HOME'}
                      onChange={(e) => updateArrayItem('contactAddresses', index, 'type', e.target.value)}
                    >
                      <MenuItem value="HOME">Casa</MenuItem>
                      <MenuItem value="WORK">Trabajo</MenuItem>
                      <MenuItem value="OTHER">Otro</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2}>
                  <IconButton
                    onClick={() => removeArrayItem('contactAddresses', index)}
                    color="error"
                    size="small"
                  >
                    <DeleteIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </Box>
          ))}
          <Button
            startIcon={<AddIcon />}
            onClick={() => addArrayItem('contactAddresses', {
              street: '', city: '', state: '', zip: '', country: '', countryCode: '', type: 'HOME'
            })}
            size="small"
          >
            Agregar dirección
          </Button>
        </AccordionDetails>
      </Accordion>

      {/* URLs */}
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body2">URLs</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {localNodeData.contactUrls?.map((url, index) => (
            <Box key={index} sx={{ mb: 2, p: 1, border: '1px solid #ddd', borderRadius: 1 }}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs={6}>
                  <TextField
                    label="URL"
                    value={url.url || ''}
                    size="small"
                    fullWidth
                    onChange={(e) => updateArrayItem('contactUrls', index, 'url', e.target.value)}
                  />
                </Grid>
                <Grid item xs={4}>
                  <FormControl fullWidth size="small">
                    <Select
                      value={url.type || 'HOME'}
                      onChange={(e) => updateArrayItem('contactUrls', index, 'type', e.target.value)}
                    >
                      <MenuItem value="HOME">Personal</MenuItem>
                      <MenuItem value="WORK">Trabajo</MenuItem>
                      <MenuItem value="OTHER">Otro</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2}>
                  <IconButton
                    onClick={() => removeArrayItem('contactUrls', index)}
                    color="error"
                    size="small"
                  >
                    <DeleteIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </Box>
          ))}
          <Button
            startIcon={<AddIcon />}
            onClick={() => addArrayItem('contactUrls', { url: '', type: 'HOME' })}
            size="small"
          >
            Agregar URL
          </Button>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}